
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MFGTransactionGrid extends Serenity.EntityGrid<MFGTransactionRow, any> {
        protected getColumnsKey() { return 'Production.MFGTransaction'; }
        protected getDialogType() { return MFGTransactionDialog; }
        protected getIdProperty() { return MFGTransactionRow.idProperty; }
        protected getInsertPermission() { return MFGTransactionRow.insertPermission; }
        protected getLocalTextPrefix() { return MFGTransactionRow.localTextPrefix; }
        protected getService() { return MFGTransactionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(68);
            this.editItem(<MFGTransactionRow>{
                VoucherNo: voucherNo,
                UserId: Q.Authorization.userDefinition.UserId,
                VoucherTypeId: 68,
                EmployeeId: 0,
                TransDate: now.toString()
            });
        }
    }
}